	const urlParams = new URLSearchParams(window.location.search);

	let getUrlParam = function(name) {
		console.log("..............TIS")
		try {
			return urlParams.get(name)
		} catch (error) {
				console.error('Error decoding URL parameter:', error);
				return null;
		}
	}

const capitalizeFirstLetter = function(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

const colorsENUM = {
	'red': [1, 9, 17, 25, 33, 41],
	'green': [2, 10, 18, 26, 34, 42],
	'blue': [3, 11, 19, 27, 35, 43],
	'purple': [4, 12, 20, 28, 36, 44],
	'brown': [5, 13, 21, 29, 37, 45],
	'yellow': [6, 14, 22, 30, 38, 46],
	'orange': [7, 15, 23, 31, 39, 47],
	'black': [8, 16, 24, 32, 40, 48]
};

const getColorByNum = function(num) {
	// console.log(">>>>>>getColorByNum", n)
	let n = parseInt(num);
	if(colorsENUM.red.indexOf(n) != -1) {
		return "red";
	}
	if(colorsENUM.green.indexOf(n) != -1) {
		return "green";
	}
	if(colorsENUM.blue.indexOf(n) != -1) {
		return "blue";
	}
	if(colorsENUM.purple.indexOf(n) != -1) {
		return "purple";
	}
	if(colorsENUM.brown.indexOf(n) != -1) {
		return "brown";
	}
	if(colorsENUM.yellow.indexOf(n) != -1) {
		return "yellow";
	}
	if(colorsENUM.orange.indexOf(n) != -1) {
		return "orange";
	}
	if(colorsENUM.black.indexOf(n) != -1) {
		return "black";
	}
};

export {
	getColorByNum,
	getUrlParam,
	capitalizeFirstLetter
}